// tslint:disable-next-line: eofline
(window as any).global = window;